var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size lg_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("TITLE.CREATE.NEW.QUESTION")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "create_wrap mt-20" }, [
              _c("table", { staticClass: "create_table" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("caption", [
                  _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.$t("FIELD.GLOBAL.MANDATORY")) +
                      "\n                            "
                  )
                ]),
                _vm._v(" "),
                "1" === _vm.deptLevelCd
                  ? _c("tr", [
                      _c("th", [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.$t("FIELD.MYKNOWLEDGE.ASC.ACCOUNT.NO"))
                        ),
                        _c("em", { staticClass: "txt_mandatory" }, [
                          _vm._v("*")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "in_td" }, [
                        _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.ascAccount,
                                expression: "ascAccount"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100p",
                            attrs: { type: "text" },
                            domProps: { value: _vm.ascAccount },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.ascAccount = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          "(" + _vm._s(_vm.$t("FIELD.GLOBAL.ASC.USER")) + ")"
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(
                      "\n                                    " +
                        _vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY"))
                    ),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")]),
                    _vm._v(" "),
                    "CN" === _vm.loginRhq
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_ss_white",
                            attrs: { href: "javascript:", title: "" },
                            on: {
                              click: function($event) {
                                return _vm.searchZHPopup("I")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.$t("BUTTON.QNA.ZH")) +
                                "\n                                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _c("fieldset", { staticClass: "ui_fieldset set_3" }, [
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inquiry1Code,
                                expression: "inquiry1Code"
                              }
                            ],
                            staticClass: "slt_white w100p",
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.inquiry1Code = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.inquiryList(2)
                                }
                              ]
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.inquiry1CodeList, function(item) {
                              return _c(
                                "option",
                                {
                                  key: _vm.pageName + item.CD,
                                  domProps: { value: item.CD }
                                },
                                [
                                  _vm._v(
                                    "\n                                                    " +
                                      _vm._s(item.CD_NAME) +
                                      "\n                                                "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inquiry2Code,
                                expression: "inquiry2Code"
                              }
                            ],
                            staticClass: "slt_white w100p",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.inquiry2Code = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.inquiry2CodeList, function(item) {
                              return _c(
                                "option",
                                {
                                  key: _vm.pageName + item.CD,
                                  domProps: { value: item.CD }
                                },
                                [
                                  _vm._v(
                                    "\n                                                    " +
                                      _vm._s(item.CD_NAME) +
                                      "\n                                                "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                "PQ1" !== _vm.inquiry1Code
                  ? _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("FIELD.FAST.ADVANCED.MODEL"))),
                        _c("em", { staticClass: "txt_mandatory" }, [
                          _vm._v("*")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { colspan: "3" } }, [
                        _c("fieldset", { staticClass: "ui_fieldset" }, [
                          _c("label", { staticClass: "serach-wrap" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.modelNm,
                                  expression: "modelNm"
                                }
                              ],
                              staticClass: "text_input cur_pointer",
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("BUTTON.GLOBAL.SEARCH"),
                                readonly: ""
                              },
                              domProps: { value: _vm.modelNm },
                              on: {
                                click: function($event) {
                                  return _vm.searchModelPopup()
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.modelNm = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm._m(1)
                          ]),
                          _vm._v(" "),
                          _c("label", { staticClass: "checkbox-wrap" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.modelCheck,
                                  expression: "modelCheck"
                                }
                              ],
                              attrs: { type: "checkbox", checked: "" },
                              domProps: {
                                checked: Array.isArray(_vm.modelCheck)
                                  ? _vm._i(_vm.modelCheck, null) > -1
                                  : _vm.modelCheck
                              },
                              on: {
                                click: function($event) {
                                  return _vm.clearModel()
                                },
                                change: function($event) {
                                  var $$a = _vm.modelCheck,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.modelCheck = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.modelCheck = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.modelCheck = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "check-icon" }),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAQ.NOT.RELEVANT")))
                            ])
                          ])
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !(
                  "PQ1" === _vm.inquiry1Code ||
                  "PQ4" === _vm.inquiry1Code ||
                  "PQ8" === _vm.inquiry1Code
                )
                  ? _c("tr", [
                      _c("th", [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY"))
                        ),
                        _c("em", { staticClass: "txt_mandatory" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        "CN" === _vm.loginRhq
                          ? _c(
                              "a",
                              {
                                staticClass: "btn_ss_white",
                                attrs: { href: "javascript:", title: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.searchZHPopup("C")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t("BUTTON.QNA.ZH")) +
                                    "\n                                    "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { colspan: "3" } }, [
                        _c("fieldset", { staticClass: "ui_fieldset set_3" }, [
                          _c("label", { staticClass: "select-wrap" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.category1Code,
                                    expression: "category1Code"
                                  }
                                ],
                                staticClass: "slt_white w100p",
                                attrs: {
                                  id: "category1Code",
                                  disabled:
                                    "Q50" === _vm.inquiry2Code ||
                                    !_vm.modelCheck
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.category1Code = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function($event) {
                                      return _vm.categoryList(2)
                                    }
                                  ]
                                }
                              },
                              _vm._l(_vm.category1CodeList, function(item) {
                                return _c(
                                  "option",
                                  {
                                    key: _vm.pageName + item.code,
                                    domProps: { value: item.code }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                    " +
                                        _vm._s(item.codeName) +
                                        "\n                                                "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]),
                          _vm._v(" "),
                          _c("label", { staticClass: "select-wrap" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.category2Code,
                                    expression: "category2Code"
                                  }
                                ],
                                staticClass: "slt_white w100p",
                                attrs: {
                                  id: "category2Code",
                                  disabled: !_vm.modelCheck
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.category2Code = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function($event) {
                                      return _vm.categoryList(3)
                                    }
                                  ]
                                }
                              },
                              _vm._l(_vm.category2CodeList, function(item) {
                                return _c(
                                  "option",
                                  {
                                    key: _vm.pageName + item.code,
                                    domProps: { value: item.code }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                    " +
                                        _vm._s(item.codeName) +
                                        "\n                                                "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]),
                          _vm._v(" "),
                          _c("label", { staticClass: "select-wrap" }, [
                            _c(
                              "select",
                              {
                                staticClass: "slt_white w100p",
                                attrs: {
                                  id: "category3Code",
                                  disabled: !_vm.modelCheck
                                }
                              },
                              _vm._l(_vm.category3CodeList, function(item) {
                                return _c(
                                  "option",
                                  {
                                    key: _vm.pageName + item.code,
                                    domProps: { value: item.code }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                    " +
                                        _vm._s(item.codeName) +
                                        "\n                                                "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.TITLE"))),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _c("span", { staticClass: "clearable" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.title,
                            expression: "title"
                          },
                          { name: "clearable", rawName: "v-clearable" }
                        ],
                        staticClass: "text_input w100p",
                        attrs: { type: "text" },
                        domProps: { value: _vm.title },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.title = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                "PQ2" === _vm.inquiry1Code ||
                "PQ3" === _vm.inquiry1Code ||
                "PQ4" === _vm.inquiry1Code ||
                "PQ8" === _vm.inquiry1Code
                  ? _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("FIELD.QNA.REPAIR.TYPE")))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "in_td" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.repairType,
                                expression: "repairType"
                              }
                            ],
                            staticClass: "slt_white w100p",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.repairType = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.repairTypeList, function(item) {
                              return _c(
                                "option",
                                {
                                  key: _vm.pageName + item.CD,
                                  domProps: { value: item.CD }
                                },
                                [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(item.CDNM) +
                                      "\n                                        "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "in_th" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("FIELD.QNA.SERIAL.NUMBER")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.serialNumber,
                                expression: "serialNumber"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100p",
                            attrs: { type: "text" },
                            domProps: { value: _vm.serialNumber },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.serialNumber = $event.target.value
                              }
                            }
                          })
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                "PQ3" === _vm.inquiry1Code
                  ? _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("FIELD.MYKNOWLEDGE.PARTS.NUMBER")))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "in_td" }, [
                        _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.partsNumber,
                                expression: "partsNumber"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100p",
                            attrs: { type: "text" },
                            domProps: { value: _vm.partsNumber },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.partsNumber = $event.target.value
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "in_th" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("FIELD.MYKNOWLEDGE.PARTS.NAME")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.partsName,
                                expression: "partsName"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100p",
                            attrs: { type: "text" },
                            domProps: { value: _vm.partsName },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.partsName = $event.target.value
                              }
                            }
                          })
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("tr", [
                  "PQ2" === _vm.inquiry1Code ||
                  "PQ4" === _vm.inquiry1Code ||
                  "PQ8" === _vm.inquiry1Code ||
                  "PQ6" === _vm.inquiry1Code ||
                  "PQ7" === _vm.inquiry1Code ||
                  "PQ9" === _vm.inquiry1Code
                    ? _c("th", [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.$t("FIELD.QNA.SVC.ORDER")) +
                            "\n                                "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  "PQ2" === _vm.inquiry1Code ||
                  "PQ4" === _vm.inquiry1Code ||
                  "PQ8" === _vm.inquiry1Code ||
                  "PQ6" === _vm.inquiry1Code ||
                  "PQ7" === _vm.inquiry1Code ||
                  "PQ9" === _vm.inquiry1Code
                    ? _c("td", { staticClass: "in_td" }, [
                        _c("span", { staticClass: "clearable" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.svcOrder,
                                expression: "svcOrder"
                              },
                              { name: "clearable", rawName: "v-clearable" }
                            ],
                            staticClass: "text_input w100p",
                            attrs: { type: "text" },
                            domProps: { value: _vm.svcOrder },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.svcOrder = $event.target.value
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  "PQ2" === _vm.inquiry1Code ||
                  "PQ3" === _vm.inquiry1Code ||
                  "D" === _vm.category1Code
                    ? _c(
                        "th",
                        { class: "PQ3" === _vm.inquiry1Code ? "" : "in_th" },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("FIELD.MYKNOWLEDGE.IMEI")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  "PQ2" === _vm.inquiry1Code ||
                  "PQ3" === _vm.inquiry1Code ||
                  "D" === _vm.category1Code
                    ? _c(
                        "td",
                        { class: "PQ3" === _vm.inquiry1Code ? "in_td" : "" },
                        [
                          _c("span", { staticClass: "clearable" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.IMEI,
                                  expression: "IMEI"
                                },
                                { name: "clearable", rawName: "v-clearable" }
                              ],
                              staticClass: "text_input w100p",
                              attrs: { type: "text" },
                              domProps: { value: _vm.IMEI },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.IMEI = $event.target.value
                                }
                              }
                            })
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  "QPA005" === _vm.inquiry2Code || "Q7" === _vm.inquiry2Code
                    ? _c("th", { staticClass: "in_th" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("FIELD.MYKNOWLEDGE.DEPOT.LOCATION"))
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  "QPA005" === _vm.inquiry2Code || "Q7" === _vm.inquiry2Code
                    ? _c("td", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.depotLocCd,
                                expression: "depotLocCd"
                              }
                            ],
                            staticClass: "slt_white w100p",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.depotLocCd = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.depotLocCdList, function(item) {
                              return _c(
                                "option",
                                {
                                  key: _vm.pageName + item.CD,
                                  domProps: { value: item.CD }
                                },
                                [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(item.CDNM) +
                                      "\n                                        "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ANSWER.REQUIRED.DATE")))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "in_td" }, [
                    _c("fieldset", { staticClass: "ui_fieldset" }, [
                      _c("label", { staticClass: "date-wrap" }, [
                        _c("input", {
                          staticClass: "date_input w100p",
                          attrs: {
                            id: "toDate",
                            type: "text",
                            placeholder: "MM.DD.YYYY",
                            readonly: "",
                            maxlength: "20"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "in_btn",
                            attrs: { href: "javascript:", id: "icoToDate" }
                          },
                          [
                            _c("i", { staticClass: "ico_date" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr_only" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DATE")))
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "to_datepicker",
                          attrs: { id: "to-picker-container" }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "in_th" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.URGENT")))])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("label", { staticClass: "checkbox-wrap" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.urgentYn,
                            expression: "urgentYn"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          "true-value": "Y",
                          "false-value": "N"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.urgentYn)
                            ? _vm._i(_vm.urgentYn, null) > -1
                            : _vm._q(_vm.urgentYn, "Y")
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.urgentYn,
                              $$el = $event.target,
                              $$c = $$el.checked ? "Y" : "N"
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.urgentYn = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.urgentYn = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.urgentYn = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("i", { staticClass: "check-icon" })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.QNA.DESC"))),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { attrs: { colspan: "3" } },
                    [
                      _c("cross-editor", {
                        attrs: {
                          editorId: _vm.pageName + "Cross",
                          editorData: _vm.questionDesc
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ATTACHMENT")))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "no_padding", attrs: { colspan: "3" } },
                    [
                      _c("innorix-upload", {
                        attrs: {
                          uploadId: _vm.pageName,
                          id: _vm.pageName,
                          name: _vm.pageName,
                          serviceType: _vm.serviceType,
                          onlyUpload: _vm.onlyUpload,
                          attachList: _vm.attach
                        },
                        on: { files: _vm.setFiles }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_wrap_full topLine" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:", title: "" },
                    on: {
                      click: function($event) {
                        return _vm.save(0)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("BUTTON.GLOBAL.REGISTER")) +
                        "\n                            "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "154px" } }),
      _vm._v(" "),
      _c("col", { staticClass: "col_width2" }),
      _vm._v(" "),
      _c("col", { staticClass: "col_width3" }),
      _vm._v(" "),
      _c("col", { staticClass: "col_width4" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "in_btn_search" }, [
      _c("i", { staticClass: "ico_input_serach" }),
      _vm._v(" "),
      _c("span", { staticClass: "sr_only" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9def122", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9def122","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/popup/createNewQuestionPopup.vue
// module id = Vy09
// module chunks = 0